<template>
  <div class="bg-white rounded-2xl shadow-md p-4">
    <div class="flex items-center justify-between mb-3">
      <h3 class="text-lg font-bold text-gray-900">{{ t("title") }}</h3>
      <SecondaryButton
        v-if="canAssignToMe"
        size="sm"
        data-test="claim-assign-to-me"
        @click="assignTo(currentHandler.id)"
      >
        {{ t("assign_to_me") }}
      </SecondaryButton>
    </div>
    <AssigneeSelector
      :assignee="claim.assignee"
      :assignees="claimsHandlers"
      :unassigned-label="t('unassigned')"
      @select="assignTo"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { useI18n } from "vue-i18n";
import { AssigneeSelector, SecondaryButton } from "@estaly/ui";

export default {
  components: { AssigneeSelector, SecondaryButton },

  props: {
    claim: { type: Object, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),
    ...mapState("estalyManagers", ["claimsHandlers"]),

    // Only claims handlers can be assigned, so the action stays hidden for the rest of the team.
    currentHandler() {
      return this.claimsHandlers.find((claimsHandler) => claimsHandler.email === this.currentUser.email);
    },

    canAssignToMe() {
      return this.currentHandler && this.claim.assignee?.id !== this.currentHandler.id;
    },
  },

  created() {
    this.fetchClaimsHandlers();
  },

  methods: {
    ...mapActions("claims", ["assign"]),
    ...mapActions("estalyManagers", ["fetchClaimsHandlers"]),

    assignTo(assigneeId) {
      this.assign({ assigneeId });
    },
  },
};
</script>

<i18n src="./ClaimAssigneeCard.i18n.json"></i18n>
